import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import './styles/PostsLinked.scss';

const PostsLinked = (props) => {
  const {
    previousPostLink,
    previousPostTitle,
    nextPostLink,
    nextPostTitle
  } = props;
  
  return (
    <div className="postsLinked">
      {
        previousPostLink &&
          <div className="postsLinked-previous">
                <div className="postLinked-item">
                  <div className="arrow-left"> {`<`} </div>
                  <Link to={previousPostLink}>
                    {previousPostTitle}
                  </Link>
                </div>
          </div>
      }
      {
        nextPostLink &&
          <div className="postsLinked-next">
                <div className="postLinked-item">
                  <Link to={nextPostLink}>
                    {nextPostTitle}
                  </Link>
                  <div className="arrow-right">{`>`}</div>
                </div>
          </div>
      }
    </div>
  )
}

export default PostsLinked;



// WEBPACK FOOTER //
// ./src/components/PostsLinked.jsx